// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ant-popover-inner {\n  margin-top: -0.52083vw !important;\n  padding: 0px !important;\n  width: 11.82292vw !important;\n  height: 5.83333vw !important;\n  border-radius: 0.83333vw !important;\n}\n.ant-popover-inner-content {\n  padding: 0px !important;\n  width: 11.82292vw !important;\n  height: 5.83333vw !important;\n  border-radius: 0.83333vw !important;\n}\n.ant-popover-inner-content :hover {\n  text-decoration: none !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
